import { api } from "..";

const endpoint = "/api/currency-rates";

// GET all currency rates with optional filters
export const getCurrencyRates = async (params = {}) => {
  const { currencySymbol, startDate, endDate, limit } = params;
  
  const queryParams = new URLSearchParams();
  
  if (currencySymbol) queryParams.append("currencySymbol", currencySymbol);
  if (startDate) queryParams.append("startDate", startDate.toISOString());
  if (endDate) queryParams.append("endDate", endDate.toISOString());
  if (limit) queryParams.append("limit", limit.toString());
  
  const url = queryParams.toString() ? `${endpoint}?${queryParams.toString()}` : endpoint;
  return api.get(url);
};

// GET USD rates specifically
export const getUSDRates = async (params = {}) => {
  const { startDate, endDate, limit = 30 } = params;
  
  const queryParams = new URLSearchParams();
  if (startDate) queryParams.append("startDate", startDate.toISOString());
  if (endDate) queryParams.append("endDate", endDate.toISOString());
  if (limit) queryParams.append("limit", limit.toString());
  
  const url = queryParams.toString() ? `${endpoint}/usd?${queryParams.toString()}` : `${endpoint}/usd`;
  return api.get(url);
};

// GET EUR rates specifically
export const getEURates = async (params = {}) => {
  const { startDate, endDate, limit = 30 } = params;
  
  const queryParams = new URLSearchParams();
  if (startDate) queryParams.append("startDate", startDate.toISOString());
  if (endDate) queryParams.append("endDate", endDate.toISOString());
  if (limit) queryParams.append("limit", limit.toString());
  
  const url = queryParams.toString() ? `${endpoint}/eur?${queryParams.toString()}` : `${endpoint}/eur`;
  return api.get(url);
};
